import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { Invoice } from '@/types/work/invoice';
import { PageMeta } from '@/types/pagination';
import products from '@/store/models/work/enterprise/invoices/products';
const PATH = 'work/enterprises/invoices/outgoing/';
export const INVOICES_REQUEST = PATH + 'request';
export const INVOICE_REQUEST = PATH + 'showRequest';
export const STORE_REQUEST = PATH + 'storeRequest';
export const GET_INVOICES = PATH + 'getInvoices';
export const GET_INVOICE = PATH + 'getInvoice';
export const GET_META = PATH + 'getMeta';
export const GET_STATUS = PATH + 'getStatus';

const state = {
  status: null,
  invoices: [],
  invoice: {},
  meta: {}
};

const getters = {
  getInvoices: (state:any):Array<Invoice> => state.invoices,
  getInvoice: (state:any):Invoice => state.invoice,
  getStatus: (state:any):boolean|null => state.status,
  getMeta: (state:any):PageMeta => state.meta
};

const actions = {
  request: ({ commit, dispatch, rootGetters }:any, filter:any = {}) => {
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({ url: `enterprise/${enterprise.id}/invoices/outgoing`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  showRequest: ({ commit, dispatch, state, rootGetters }:any, id:number) => {
    state.invoices.forEach((inv:Invoice) => {
      if (inv.id === id) {
        commit('setInvoice', inv);
      }
    });
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({ url: `enterprise/${enterprise.id}/invoices/outgoing/${id}` })
      .then((resp:any) => {
        commit('successShow', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  store: () => {
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:any) => {
    state.status = true;
    state.invoices = resp.data;
    state.meta = resp.meta;
  },
  successShow: (state:any, resp:any) => {
    state.status = true;
    state.invoice = resp.data;
  },
  setInvoice: (state:any, invoice:Invoice) => {
    state.invoice = invoice;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.invoices.length; i++) {
        if (state.invoices[i].id === resp.id) {
          state.invoices[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.invoices[state.invoices.length] = resp;
      }
    } else {
      state.invoices[state.invoices.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    products: products
  }
};
